import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { SectionHeader } from 'components/molecules';

const useStyles = makeStyles(theme => ({
  textWhite: {
    color: 'white',
    textTransform: 'uppercase',
  },
  textWhite1: {
    color: 'white',
    textTransform: 'uppercase',
  },
}));

const SolutionProductService = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  return (
    <div className={className} {...rest}>
      <SectionHeader
        title={<span className={classes.textWhite}>Services & Solutions</span>}
        titleVariant="h1"
        subtitle={<span className={classes.textWhite}>You may be offering the best & unique Products or Services. How the world will know to consume?</span>}
        disableGutter
        data-aos="fade-up"
      />
    </div>
  );
};

/*

ctaGroup={[
  <Button variant="outlined" color="secondary" size="large">
    See portfolio
  </Button>,
]}

*/


SolutionProductService.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default SolutionProductService;
